import './dashboard_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.ClonedDashboardView extends Monitoring.Views.SocialContents.DashboardView

  initialize: (@options = {}) ->
    if @options.searchQuery.get('show_share_session')
      @options.defaultMode = 'visual'
    super(@options)
    @searchIsPending = true
    @defaultCharts = @options.defaultCharts
    @searchQuery = @options.searchQuery
    @searchQuery.set('uuid', @uuid)
    @searchQuery.set('name', '')
    @searchQuery.set('offset', 0)
